import type { ChartConfig } from "../chart-interfaces";
import { DataValueType } from "../options";
import type { Options } from "../types";

/**
 * Create chart configuration from options for the chart interface
 *
 * @param options Selected options
 * @returns Chart configuration
 */
export const createChartConfig = (options: Options): ChartConfig => {
  const isChange = options.dataValueType === DataValueType.CHANGE;
  const isShare = false; // TODO: implement share
  const yAxisTitle = isChange
    ? "Change (% from prev year)"
    : isShare
    ? "Share"
    : "";

  // TODO: implement custom aggregatedToMonth (e.g. data May-July)
  let aggregatedToMonth = undefined;
  if (options.dateFilter.length === 2) {
    aggregatedToMonth = options.dateFilter[0] + " " + options.dateFilter[1];
  } else {
    aggregatedToMonth = options.dateFilter[0];
  }

  return {
    chart: {
      title: undefined, // TODO: implement chart title
    },
    xAxis: {
      aggregatedToMonth: aggregatedToMonth,
    },
    yAxis: {
      title: yAxisTitle,
      isPercent: isChange || isShare,
    },
    data: {
      showPrevious: options.dataValueType === DataValueType.PREVIOUS,
    },
  };
};
